import type { ApiResponse, LyricDto } from '@lyricshub/shared';
import { api } from './api';

export interface LrcLine {
  time: number;
  text: string;
}

export interface LyricVersionDto {
  id: string;
  songId: string;
  plainText: string;
  lrcContent: string | null;
  createdAt: string;
  createdBy: { id: string; username: string } | null;
}

export const lyricsService = {
  async getLyrics(songId: string): Promise<ApiResponse<LyricDto>> {
    const response = await api.get(`/songs/${songId}/lyrics`);
    return response.data;
  },

  async getLrc(songId: string): Promise<ApiResponse<{ lrcContent: string; lines: LrcLine[] }>> {
    const response = await api.get(`/songs/${songId}/lyrics/lrc`);
    return response.data;
  },

  async getVersions(songId: string): Promise<ApiResponse<LyricVersionDto[]>> {
    const response = await api.get(`/songs/${songId}/lyrics/versions`);
    return response.data;
  },
};
